import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { useFormulario } from './useFormulario.js';

const Formulario = ({ onSave, onCancel, codigo, render }) => {
    const { updateDescripcion, updateCodigoRespuesta, handleSubmit, codigoRespuesta, 
        descripcion } = useFormulario(onSave, onCancel, codigo, render);

    return (
        <form onSubmit={handleSubmit}>
            <div className="fila-form">
                <div className="columna-form">
                    <label>
                        Código Respuesta:
                    </label>
                    <Tooltip title="Código Respuesta">
                        <input className='input-form' placeholder='Código Respuesta' type="text" value={codigoRespuesta} onChange={(e) => updateCodigoRespuesta(e.target.value)} disabled={render === 'View' ? true : null} />
                    </Tooltip>
                </div>
                <div className="columna-form">
                    <label>
                        Descripción:
                    </label>
                    <Tooltip title="Descripción">
                        <input className='input-form' placeholder='Descripción' type="text" value={descripcion} onChange={(e) => updateDescripcion(e.target.value)} disabled={render === 'View' ? true : null} />
                    </Tooltip>
                </div>
            </div>
            <div className="fila-form">
                <div className="button-form">
                    {render !== 'View' && (
                        <Tooltip title="Aceptar">
                            <button id="btn-accion" className="action-button">Aceptar</button>
                        </Tooltip>
                    )}
                    <Tooltip title="Cancelar">
                        <button className="action-button" onClick={onCancel}>Cancelar</button>
                    </Tooltip>
                </div>
            </div>
        </form>
    );
};
export { Formulario };